import {
  Component,
  ElementRef,
  HostListener,
  inject,
  OnDestroy,
  OnInit,
  ViewChild,
} from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { AuthFacade, SharedFacade } from '@piqet-angular/data';
import {
  CustomModalService,
  emailRegex,
  PIQET,
  registerPageTitle,
  SignupSourceType,
  SignupSourceTypeArray,
  FileUploadResult,
} from '@piqet-angular/shared';
import { environment } from 'apps/piqet-angular/src/environments/environment';
import { MustMatch } from './must-match.validator';
import { Helper, noWhitespaceValidator } from '../../../../shared/src/lib/service/helper.service';
import { AuthenticationService } from 'libs/data/src/lib/services/auth/authentication.service';
import { ActivatedRoute } from '@angular/router';
import { SharedService } from 'libs/data/src/lib/services/shared/shared.service';
import { Title } from '@angular/platform-browser';
export class Model {
  name: string;

  constructor(name: string) {
    this.name = name;
  }
}

@Component({
  selector: 'piqet-angular-register',
  templateUrl: './register.component.html',
  styleUrls: ['./register.component.scss'],
})
export class RegisterComponent implements OnInit, OnDestroy {
  signUpSourceList: any;
  registerForm!: FormGroup;
  siteKey: any;
  imagePreview!: any;
  selectedFiles: any;
  submitted = false;
  addressValue: string = '';
  isChecked = false;
  purchaseType = 'trypiqet';
  isImageValid = true;
  fieldTextTypeNewPwd = false;
  fieldTextTypeConfirmPwd = false;
  specialCharactersflag = true;
  upperCaseCharactersflag = true;
  lowerCaseCharactersflag = true;
  numberCharactersflag = true;
  minLengthsflag = true;
  checkValidationForOrg: any;
  typeSelected = 'line-spin-clockwise-fade';
  isLogoConsented: boolean = true;
  activeRoute: any;
  isTrial: boolean = false;
  sourceType!: number | null;
  showCommentBox: boolean = false;
  labelText: string = 'Comment';
  sharedService = inject(SharedService);
  title = inject(Title);
  currentEmail: string = '';
  isEmailValid: boolean = true;
  isEmailValidationPending: boolean = true;
  lastValidatedEmail: string | null = null;
  lastSelectedCountry: any = null;
  @ViewChild('emailInput') emailInput!: ElementRef<HTMLInputElement>;
  @ViewChild('fileUploadComponent') fileUploadComponent: any;
  constructor(
    private formBuilder: FormBuilder,
    private authFacade: AuthFacade,
    public sharedFacade: SharedFacade,
    private modal: CustomModalService,
    private route: ActivatedRoute,
    private authService: AuthenticationService
  ) {}

  @HostListener('window:click', ['$event.target']) // Replace 'yourEvent' with the actual event you want to listen to
  getNgSelectEvent(e: any) {
    if (
      e?.classList?.contains('ng-value-container') ||
      e?.classList?.contains('ng-arrow-wrapper') ||
      e?.classList?.contains('ng-select-container') ||
      e?.classList?.contains('ng-input') ||
      e?.classList?.contains('ng-placeholder')
    ) {
      const divElement: any = document.getElementsByClassName('ng-select-opened');
      if (divElement) {
        const data = divElement[0]?.getElementsByTagName('input');
        if (data) {
          data[1]?.focus();
        }
      }
    }
  }

  ngOnInit(): void {
    this.title.setTitle(registerPageTitle);
    this.sharedService.loadGTScript();
    this.activeRoute = this.route.snapshot.routeConfig?.path;
    this.signUpSourceList = SignupSourceTypeArray;
    this.isTrial = this.activeRoute == 'register/freeTrial' ? true : false;
    this.sharedFacade.clearEmailValidation();
    this.sharedFacade.getCountryList();
    const reg = emailRegex;
    const pwdReg = '^(?=.*?[A-Z])(?=.*?[a-z])(?=.*?[0-9])(?=.*?[#?!@$%^&*-]).{8,}$';
    this.registerForm = this.formBuilder.group(
      {
        Country: [null],
        PlanName: [null],
        Firstname: ['', [Validators.required, Validators.minLength(2), noWhitespaceValidator]],
        Lastname: ['', [Validators.required, Validators.minLength(2), noWhitespaceValidator]],
        email: ['', [Validators.required, Validators.email, Validators.pattern(reg)]],
        Password: ['', [Validators.required, Validators.pattern(pwdReg)]],
        ConfirmPassword: ['', Validators.required],
        OrganisationName: ['', Validators.required],
        OrganisationLogo: [null],
        address: [''],
        IsAgree: [false, Validators.requiredTrue],
        recaptcha: ['', Validators.required],
        source: [null, Validators.required],
        sourceComment: [''],
      },
      {
        validator: MustMatch('Password', 'ConfirmPassword'),
      }
    );
    this.registerForm.get('email')?.valueChanges.subscribe(value => {
      if (value == '') {
        this.sharedFacade.clearEmailValidation();
      }
    });
    this.siteKey = environment.locationPath.includes('https://app.piqet.com')
      ? '6Le3jfgZAAAAADgEdIxBkOR-_MbjPC2LkGw2yw--'
      : '6LfADGMqAAAAAN27UVw7ux3x5Dh46YADBTB0L7Bp';
    if (this.isTrial) {
      this.registerForm.get('Country')?.clearValidators();
      this.registerForm.get('PlanName')?.clearValidators();
      this.registerForm.get('address')?.clearValidators();
    } else {
      this.registerForm.controls['Country'].setValidators(Validators.required);
      this.registerForm.controls['PlanName'].setValidators(Validators.required);
      this.registerForm.get('address')?.setValidators(Validators.required);
    }
    this.registerForm.get('Country')?.updateValueAndValidity();
    this.registerForm.get('PlanName')?.updateValueAndValidity();
    this.registerForm.get('address')?.updateValueAndValidity();
    this.registerForm.get('OrganisationName')?.valueChanges.subscribe(() => {
      if (this.checkValidationForOrg?.data === false) {
        this.checkValidationForOrg = null;
      }
    });
  }

  onFileSelected(fileResult: FileUploadResult) {
    if (fileResult.isValid && fileResult.file) {
      this.selectedFiles = fileResult.file;
      this.imagePreview = fileResult.fileUrl;
      this.isImageValid = true;
      this.registerForm.patchValue({ OrganisationLogo: this.selectedFiles });
      this.registerForm.get('OrganisationLogo')?.updateValueAndValidity();
    } else {
      this.isImageValid = false;
    }
  }

  onImagePicked(fileInput: any) {
    this.imagePreview = '';
    this.selectedFiles = fileInput.target.files[0];
    const mimeType = this.selectedFiles?.type;
    if (mimeType?.match(/image\/*/) == null) {
      this.imagePreview = '';
      this.isImageValid = false;
      return;
    } else {
      this.imagePreview = '';
      this.isImageValid = true;
      this.registerForm.patchValue({ OrganisationLogo: this.selectedFiles });
      this.registerForm.get('OrganisationLogo')?.updateValueAndValidity();
      if (this.selectedFiles) {
        const reader = new FileReader();
        reader.onload = (event: any) => {
          this.imagePreview = reader.result as string;
        };
        reader.readAsDataURL(this.selectedFiles);
      }
    }
  }

  commonInputSearch(term: string, item: any) {
    return item.name.toLowerCase().includes(term.toLowerCase());
  }

  openTermsPdf() {
    this.modal.invoke('termsAndConditions', {
      initialState: {
        isTermsAndCondition: true,
        isVerification: false,
      },
      class: 'modal-xl',
    });
  }

  removeImage() {
    // Clear all file-related properties
    this.selectedFiles = null;
    this.imagePreview = '';
    this.isImageValid = true;

    // Update the form control
    this.registerForm.patchValue({ OrganisationLogo: null });
    this.registerForm.get('OrganisationLogo')?.updateValueAndValidity();

    // Reset the file upload component if available
    if (this.fileUploadComponent) {
      this.fileUploadComponent.clearFile();
    }
  }

  get displayFileName(): string | null {
    return this.selectedFiles ? this.selectedFiles.name : null;
  }

  onChange(event: any) {
    this.registerForm.controls['PlanName'].setValue(null);

    // If no country selected (cleared) or invalid event, just clear plans
    if (!event ?? !event.description) {
      this.lastSelectedCountry = null;
      this.sharedFacade.clearPlanList();
      return;
    }

    // Skip if same country selected
    if (this.lastSelectedCountry?.description === event.description) {
      return;
    }

    this.lastSelectedCountry = event;

    // Fetch plans for selected country
    this.sharedFacade.clearPlanList();
    this.sharedFacade.getPlanList(event);
  }

  openPaymentTCModal() {
    this.modal.invoke('paymentTermsAndCondition', {
      initialState: {
        onSuccess: () => {},
      },
      class: 'modal-xl',
    });
  }

  toggleFieldNewPwd() {
    this.fieldTextTypeNewPwd = !this.fieldTextTypeNewPwd;
  }
  toggleFieldConfirmPwd() {
    this.fieldTextTypeConfirmPwd = !this.fieldTextTypeConfirmPwd;
  }
  validationsPassword() {
    const isValidate = Helper.passwordValidatior(this.registerForm.controls['Password'].value);
    this.upperCaseCharactersflag = isValidate.upperCaseCharactersflag;
    this.lowerCaseCharactersflag = isValidate.lowerCaseCharactersflag;
    this.numberCharactersflag = isValidate.numberCharactersflag;
    this.specialCharactersflag = isValidate.specialCharactersflag;
    this.minLengthsflag = isValidate.minLengthsflag;
  }

  updateConsent(eve: any) {
    this.isLogoConsented = eve.target.checked;
  }

  async registerUser(purchaseType: any) {
    this.submitted = true;
    this.isChecked = true;
    if (
      !this.registerForm.valid ||
      this.isImageValid == false ||
      this.isEmailValid ||
      this.isEmailValidationPending
    ) {
      if (this.isEmailValidationPending) {
        this.emailInput.nativeElement.focus();
        return;
      }
      this.registerForm.markAllAsTouched();
      return;
    }

    if (purchaseType == 'purchase' || purchaseType == 'trypiqet') {
      sessionStorage.setItem('registerEmail', this.registerForm.value.email);
    }
    const url =
      purchaseType === 'purchase'
        ? '/#/activate-user?activationCode=' //handles email verification specifically for purchase users
        : '/#/activate-user?trialCode='; //handles email verification specifically for trial users
    const registerUserData = {
      CountryId: this.registerForm.value.Country?.id,
      PlanId: this.registerForm.value.PlanName?.idStr,
      Firstname: this.registerForm.value.Firstname,
      Lastname: this.registerForm.value.Lastname,
      UserName: this.registerForm.value.email,
      Password: this.registerForm.value.Password,
      ConfirmPassword: this.registerForm.value.ConfirmPassword,
      OrganisationName: this.registerForm.value.OrganisationName,
      IsAgree: this.registerForm.value.IsAgree,
      logoConsent: this.isLogoConsented,
      address: this.registerForm.value.address,
      signupSource: this.sourceType,
      signupSourceComment:
        this.sourceType == SignupSourceType.Other ||
        this.sourceType == SignupSourceType.ConferenceTradeEvent
          ? this.registerForm.value.sourceComment
          : null,
      VerifyUserUrl: encodeURIComponent(environment.locationPath + url),
      ...(purchaseType == 'purchase' && {
        ChargBeeThanksUrl: encodeURIComponent(environment.locationPath + `/#/purchase-thanks`),
        ChargBeeCancleUrl: encodeURIComponent(environment.locationPath + `/#/purchase-cancel`),
      }),
    };
    const checkType = await this.authService.CheckOrganization(registerUserData);
    this.checkValidationForOrg = checkType;
    purchaseType != 'nextConfirm' &&
      checkType?.data &&
      this.authFacade.register(registerUserData, purchaseType);
    this.submitted = false;
  }
  changeEmail(event: any) {
    this.currentEmail = '';
  }
  getEmailValidation() {
    this.isEmailValidationPending = false;
    const emailControl = this.registerForm.get('email');
    const currentEmail = emailControl?.value;

    // Skip API call if email is unchanged and valid
    if (currentEmail === this.lastValidatedEmail) {
      return;
    }

    // Mark validation pending and reset validation status
    this.isEmailValidationPending = true;
    if (!emailControl?.valid) {
      return;
    }

    const payload = {
      id: 0,
      email: currentEmail,
    };

    this.sharedService.isEmailExist(payload).subscribe((data: any) => {
      this.isEmailValidationPending = false;
      if (!data.messageType) {
        this.currentEmail = currentEmail;
        this.lastValidatedEmail = currentEmail; // Update last validated email
        this.isEmailValid = data.data.value;
      }
    });
  }

  selectedSource(eve: any) {
    if (!eve.id) return;
    this.sourceType = eve.id;
    if (
      this.sourceType == SignupSourceType.Other ||
      this.sourceType == SignupSourceType.ConferenceTradeEvent
    ) {
      this.showCommentBox = true;
      this.labelText =
        this.sourceType == SignupSourceType.Other ? 'Comment' : 'Please specify the event';
      this.registerForm.controls['sourceComment'].clearValidators();
      this.registerForm.controls['sourceComment'].reset();
      this.registerForm.controls['sourceComment'].setValidators([
        Validators.required,
        Validators.pattern(/\S+/),
        // At least one non-space character
      ]);
    } else {
      this.showCommentBox = false;
      this.registerForm.controls['sourceComment'].clearValidators();
      this.registerForm.controls['sourceComment'].reset();
    }
    this.registerForm.updateValueAndValidity();
  }

  clearSource() {
    this.sourceType = null;
    this.showCommentBox = false;
    this.registerForm.controls['sourceComment'].clearValidators();
    this.registerForm.controls['sourceComment'].reset();
    this.registerForm.updateValueAndValidity();
  }

  ngOnDestroy() {
    this.sharedService.removeGTScript();
    this.title.setTitle(PIQET);
    this.lastSelectedCountry = null;
  }
  preventSemicolon(event: KeyboardEvent): void {
    if (event.key === ';') {
      event.preventDefault(); // Block the semicolon key press
    }
  }
}
